var angular = require('angular');
var _module = require('./index');

_module.directive('productBenefits', [function () {
    return {
        restrict: 'E',
        templateUrl: 'js/components/modals/templates/product-benefits.tmpl.html',
        scope: {
            isMobile: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: [
            function() {
                var vm = this;

            }
        ]
    };
}]);
